import { render, staticRenderFns } from "./GpayDepositForm.vue?vue&type=template&id=50d61d8e&scoped=true"
import script from "./GpayDepositForm.vue?vue&type=script&lang=js"
export * from "./GpayDepositForm.vue?vue&type=script&lang=js"
import style0 from "./GpayDepositForm.vue?vue&type=style&index=0&id=50d61d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d61d8e",
  null
  
)

export default component.exports